export const menu = {
    label: 'Alterar Cadastro SSE',
    icon: 'pi pi-bars',
    rules: ['NAN-PARCEIROSPJ-01'],
    to: '/nan/parceiropj',
};
